import Head from "next/head";
import React from "react";

import SignInComponent from "../../components/SignIn";

const SignIn = () => {
  return (
    <>
      <Head>
        <title>WinShopCRM | Přihlášení</title>
      </Head>
      <SignInComponent />
    </>
  );
};

export default SignIn;
